import { customerIndexValidate } from '../../application/dtos/customer_index_validate'

export class customerIndexEntity {
    constructor({id, name, country, state, contact_phone, rfid_by_product, email, client_type, guides_service}){
        this.id = id;
        this.name = name;
        this.country = country;
        this.state = state;
        this.contact_phone = contact_phone;
        this.rfid_by_product = rfid_by_product;
        this.email = email;
        this.client_type = client_type;
        this.guides_service = guides_service;
    }

    isValid() {
        return customerIndexValidate(this);
    }
}